<div class="change-password-modal">
  <!-- Header Section -->
  <div class="modal-header-section">
    <div class="header-icon-box">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 14C9.76142 14 12 11.7614 12 9C12 6.23858 9.76142 4 7 4C4.23858 4 2 6.23858 2 9C2 11.7614 4.23858 14 7 14Z" fill="#F59E0B" stroke="#000000" stroke-width="1.6"/>
        <circle cx="6" cy="8" r="1.6" fill="#135b89" stroke="#000000" stroke-width="1.2"/>
        <path d="M10.8 11.2L20.5 20.9M15 16.5L17.5 19M17 14.5L19.5 17" stroke="#F59E0B" stroke-width="3" stroke-linecap="round"/>
        <path d="M10.8 11.2L20.5 20.9M15 16.5L17.5 19M17 14.5L19.5 17" stroke="#000000" stroke-width="1.6" stroke-linecap="round"/>
      </svg>
    </div>
    <div class="header-text-box">
      <h3 class="modal-title">Change Password</h3>
      <p class="modal-subtitle">Update the sign-in password</p>
    </div>
  </div>

  <!-- Body Section -->
  <div class="modal-body-section">
    <!-- Sub-Admin Profile Card -->
    <div class="sub-admin-card" *ngIf="adminInfo">
      <div class="admin-avatar">
        {{ adminInitials }}
      </div>
      <div class="admin-details">
        <div class="admin-name">{{ adminFullName }}</div>
        <div class="admin-meta">
          <span>Sub-Admin</span>
          <span class="meta-dot">·</span>
          <span class="admin-email">{{ adminEmail }}</span>
        </div>
      </div>
    </div>

    <!-- New Password Field -->
    <div class="form-group-custom">
      <label class="input-label">New Password</label>
      <div class="input-wrapper">
        <input
          [type]="hideNewPassword ? 'password' : 'text'"
          [(ngModel)]="password"
          (input)="errorMessage = ''"
          name="newPassword"
          placeholder="Enter new password"
          class="custom-input"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="btn-eye-toggle"
          (click)="hideNewPassword = !hideNewPassword"
          tabindex="-1"
          aria-label="Toggle new password visibility"
        >
          <i class="fa" [ngClass]="hideNewPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
        </button>
      </div>

      <!-- Password Strength Indicator (4 segmented bars) -->
      <div class="strength-bars">
        <div
          class="strength-bar"
          [style.background-color]="strengthScore >= 1 ? strengthColor : '#e2e8f0'"
        ></div>
        <div
          class="strength-bar"
          [style.background-color]="strengthScore >= 2 ? strengthColor : '#e2e8f0'"
        ></div>
        <div
          class="strength-bar"
          [style.background-color]="strengthScore >= 3 ? strengthColor : '#e2e8f0'"
        ></div>
        <div
          class="strength-bar"
          [style.background-color]="strengthScore >= 4 ? strengthColor : '#e2e8f0'"
        ></div>
      </div>

      <div class="strength-hint">
        Use 8+ characters with a number and symbol
      </div>
    </div>

    <!-- Confirm Password Field -->
    <div class="form-group-custom">
      <label class="input-label">Confirm Password</label>
      <div class="input-wrapper">
        <input
          [type]="hideConfirmPassword ? 'password' : 'text'"
          [(ngModel)]="confirmPassword"
          (input)="errorMessage = ''"
          name="confirmPassword"
          placeholder="Re-enter new password"
          class="custom-input"
          autocomplete="new-password"
        />
        <button
          type="button"
          class="btn-eye-toggle"
          (click)="hideConfirmPassword = !hideConfirmPassword"
          tabindex="-1"
          aria-label="Toggle confirm password visibility"
        >
          <i class="fa" [ngClass]="hideConfirmPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
        </button>
      </div>
    </div>

    <!-- Error Alert Message -->
    <div class="error-alert" *ngIf="errorMessage">
      <i class="fa fa-circle-exclamation mr-1"></i>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- Actions Section -->
    <div class="modal-actions-section">
      <button type="button" class="btn btn-modal-cancel" (click)="closeDialog()">
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-modal-submit"
        [ngClass]="{ 'is-ready': password && confirmPassword }"
        (click)="btn_updatePassword()"
        [disabled]="loading"
      >
        <span *ngIf="!loading">Submit</span>
        <span *ngIf="loading"><i class="fa fa-spinner fa-spin mr-1"></i> Submitting...</span>
      </button>
    </div>
  </div>
</div>